import React, { useState, useEffect } from 'react';
import { AccessListItemPerson, AccessScreenHeader } from 'screens/AuditScreens/components';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/react-hooks';
import { AccessFetchError } from '../components/AccessFetchError/AccessFetchError';
import { AuthLoader } from 'screens/LoginScreen';
import { handleFetchMoreError } from 'services';
import { useInView } from 'react-intersection-observer';
import { PersonalAccountAccessQuery } from 'services/apollo/auditQueries/auditQueries';
import { FeedListInfinitySpinner } from 'components';

import auditLayoutStyles from './AuditLayout.module.scss';

export const PersonalAccountAuditScreen = () => {
  const { t } = useTranslation();
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const { data, fetchMore, error } = useQuery(PersonalAccountAccessQuery, {
    variables: { first: 20, cursor: '' },
    fetchPolicy: 'cache-and-network',
  });

  const [ref, inView] = useInView({
    rootMargin: '500px 0px',
    threshold: 0,
  });

  useEffect(() => {
    if (inView === true) {
      triggerFetchMore().then((response) => response);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  const triggerFetchMore = async () => {
    setIsLoadingMore(true);
    const { endCursor } = data.documentSecurityAudit.personalAccountAccess.pageInfo;

    try {
      await fetchMore({
        variables: { first: 20, cursor: endCursor },
        updateQuery: (prevResult: any, { fetchMoreResult }) => {
          fetchMoreResult.documentSecurityAudit.personalAccountAccess.contacts = [
            ...prevResult.documentSecurityAudit.personalAccountAccess.contacts,
            ...fetchMoreResult.documentSecurityAudit.personalAccountAccess.contacts,
          ];
          setIsLoadingMore(false);
          return fetchMoreResult;
        },
      });
    } catch (e) {
      handleFetchMoreError(e);
    }
  };

  if (data === undefined) {
    return <AuthLoader type="DSA"  />;
  }

  if (error) {
    return <AccessFetchError />;
  }

  return (
    <div className={auditLayoutStyles.screen}>
      <div className={auditLayoutStyles.header}>
        <AccessScreenHeader
          title={`${data.documentSecurityAudit.personalAccountAccess.pageInfo.total.toLocaleString()} ${t(
            'personalAccountScreen.title'
          )}`}
        />
      </div>
      {data.documentSecurityAudit.personalAccountAccess.contacts.map(
        (person: any, key: number) => (
          <AccessListItemPerson
            key={key}
            person={person}
            buttonMessage={t('personalAccountScreen.list-item-button')}
            showIntegrations={true}
            type="Full"
          />
        )
      )}
      {data.documentSecurityAudit.personalAccountAccess.pageInfo.hasNextPage && (
        <div ref={ref}>
          <FeedListInfinitySpinner isLoadingMore={isLoadingMore} />
        </div>
      )}
    </div>
  );
};
